export default __webpack_public_path__ + "static/media/onboarding-graphics-education.fab86430.png";